import { useState } from 'react';

const DOMAIN_REGEX =
  /^(?:(?:(?:[a-zA-Z-]+):\/{1,3})?(?:[a-zA-Z0-9])(?:[a-zA-Z0-9\-.]){1,61}(?:\.[a-zA-Z]{2,})+|\[(?:(?:(?:[a-fA-F0-9]){1,4})(?::(?:[a-fA-F0-9]){1,4}){7}|::1|::)\]|(?:(?:[0-9]{1,3})(?:\.[0-9]{1,3}){3}))(?::[0-9]{1,5})?$/i;

const ERROR_TEXT = 'Поле обязательно к заполнению';

const useValidateDomain = (initialValue = '') => {
  const [name, setName] = useState(initialValue);
  const [nameIsBlur, setNameIsBlur] = useState(false);
  const [nameError, setNameError] = useState(initialValue ? '' : ERROR_TEXT);
  const [formIsSuccess, setFormIsSuccess] = useState(false);

  const formIsValid = !nameError && name.trim().length > 0;

  const validate = (value) => {
    const trimmed = String(value ?? '').trim();

    if (!trimmed) {
      setNameError(ERROR_TEXT);

      return false;
    }

    if (!DOMAIN_REGEX.test(trimmed.toLowerCase())) {
      setNameError('Не валидное имя домена');

      return false;
    }

    setNameError('');

    return true;
  };

  const nameHandler = (e) => {
    const value = e.target.value;

    setName(value);
    validate(value);
  };

  const blurHandler = () => {
    setNameIsBlur(true);
  };

  const resetForm = () => {
    setName('');
    setNameIsBlur(false);
    setNameError(ERROR_TEXT);
    setFormIsSuccess(false);
  };

  return {
    name,
    nameIsBlur,
    nameError,
    formIsValid,
    formIsSuccess,
    domainData: { name },
    nameHandler,
    blurHandler,
    resetForm,
    setName,
    setNameError,
    setFormIsValid: () => {},
    setFormIsSuccess,
    validate,
  };
};

export default useValidateDomain;
